/**
 * Created by jiachenpan on 16/11/18.
 */

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
export function parseTimeForHandUp(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  if(time == '' || time == 0){
    return '暂无'
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function urlEncode(url){
  return encodeURIComponent(url)
}

export function urlDecode(url){
  return decodeURIComponent(url)
}


export function vipType(company){
  let level = company.vip_level+''
  let vip = level.substr(0,1)
  return vip
}

export function isAuthCompany(company,module){

  //判断是否有权限 查找当前公司权限
  if(company){
    if(!company.module){
        return false
    }
    let companyModule = module
    if(company.module[companyModule]){
        if(company.module[companyModule].have!=1){
            return false
        }
    }else{
        return false
    }
  }
  return true

}

export function isAuthUser(user,module){

  //判断是否有权限 查找当前公司权限
  if(user){
    if(!user.module){
        return false
    }
    let companyModule = module
    if(user.module[companyModule]){
        if(user.module[companyModule].have!=1){
            return false
        }
    }else{
        return false
    }
  }
  return true

}


export function isAuth(company,module){
  //判断是否有权限 查找当前公司权限
  if(company){
    if(!company.module){
        return false
    }
    let companyModule = module
          if(company.module[companyModule]){
              if(company.module[companyModule].have!=1){
                  return false
              }
              if(company.role){
                if(!company.role.module){
                    return false
                }
                  if(company.role.module[companyModule]){
                      if(company.role.module[companyModule].have!=1){
                          return  false
                      }
                  }else{
                      return  false
                  }
              }else{
                  return  false
              }
          }else{
              return false
          }
  } else {
      return false;
  }
  return true

}

//订单流程显示
export function isProcessShow(process,module){
    //判断是否有权限 查找当前公司权限
    if(process){
        if (process[module]) {
            if (parseInt(process[module].have)) {
                if (!parseInt(process[module].order_config) || parseInt(process[module].order_config) == 9) {
                    return false
                }
            } else {
                return false
            }
        } else {
            return false
        }
    } else {
        return false
    }
    return true

}

//专门用于报修部门 只要不是设置不显示 其它情况都显示 包括无此设置
export function isProcessNotShow(process,module){
  //判断是否有权限 查找当前公司权限
  if(process){
      if (process[module]) {
          if (parseInt(process[module].have)) {
              if (  parseInt(process[module].have)==0 ||(parseInt(process[module].order_config) && parseInt(process[module].order_config) == 9) ) {
                  return true;
              }
           }else{
            return true;
           }    
      } 
  }
  return false;
}

//订单流程必填
export function isProcessMust(process,module){
    //判断是否有权限 查找当前公司权限
    if(process){
        if (process[module]) {
            if (parseInt(process[module].have)) {
                if (parseInt(process[module].order_config) != 2) {
                    return false
                }
            } else {
                return false
            }
        } else {
            return false
        }
    } else {
        return false
    }
    return true

}

//判断是否手机游览器
export function isMobileBrowser() {
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) ){
        return false;
    } else {
        return true;
    }
}


//判断是否是微信浏览器的函数
export function isWeiXin(){
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
  return true;
  }else{
  return false;
  }
}

//判断是否是 茂信、政务浏览器
export function isWeiXinWorkLocal(){
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有 wxworklocal 字符串
  if(ua.match(/wxworklocal/i) == 'wxworklocal'){
  return true;
  }else{
  return false;
  }
}

//判断是否是企业微信浏览器
export function isWeiXinWork(){
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有 wxwork 字符串
    if(ua.match(/wxwork/i) == 'wxwork'){
        return true;
    }else{
        return false;
    }
}

export function timeToTimestamp(time){
  let dateTmp = time.replace(/-/g,'/')   //为了兼容IOS，需先将字符串转换为'2018/9/11 9:11:23'
  let timestamp = Date.parse(dateTmp)    //返回'2018-9-12 9:11:23'的时间戳
  return timestamp/1000;
}




// WEBPACK FOOTER //
// ./src/utils/index.js